module.exports = __webpack_public_path__ + "media/images/icons/material/help-circle-c732ad9063b34b006fe84e2040acc02d.svg";